import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import shouldLoadDyna from "@/bit/core/next13.core.utils.should-load-dyna";
import RouteHandler from "@/bit/core/next13.core.route-handler";
import WebviewBridge from "@/bit/core/next13.core.scripts.webview-bridge";
import Saam from "@/bit/core/next13.core.scripts.saam";
import OneTrust from "@/bit/components/next13.components.one-trust";
const Dyna = dynamic(() => import("@/bit/core/next13.core.scripts.dyna"));
import ErrorBoundary from "@/component/error-boundary";
import { wrapper } from "store";
import "@/styles/globals.scss";
import "@/styles/skeleton.scss";

 /* [STYLES] begins */ 
 import '@/styles/globals.scss'; 
 import '@/styles/grid.scss'; 
 import '@/styles/colors.scss'; 
 import '@/styles/fonts.scss';
 
 /* [STYLES] ends */ 

import "@/styles/card.scss";
import "@/styles/image-slider.scss";
import "@/styles/tv-card.scss";
import "@/styles/product-modal.scss";
import "@/styles/tv-filters.scss";

const App = ({ Component, pageProps, ...rest }) => {
  const Modal = useSelector((state) => state.modals.Modal);
  return (
    <>
      <WebviewBridge />
      <RouteHandler />
      <ErrorBoundary>
        <Component {...pageProps} />
        {Modal && Modal}
        <OneTrust />
      </ErrorBoundary>
      <Saam />
      {shouldLoadDyna() && <Dyna />}
      {/*APP DELIMITER*/}
    </>
  );
};

export default wrapper.withRedux(App);
